import React, { useState, useEffect } from "react";
import Table from "../../components/Table/Table";
import TopNavbar from "../../components/TopNavbar/TopNavbar";
import ApiManager from "../../ApiManager/ApiManager";
import NewFuelTransaction from "../Fuel/NewFuelTransction";
import Modal from "../../components/Modal/Modal";
import ViewEntity from "../../components/ViewEntity/ViewEntity";
import FilterBar from "../../components/FilterBar/FilterBar";
import { useAuth } from "../../components/AuthProvider";
import { useNavigate } from "react-router-dom";

import {
  hasPermission,
  ShowButton,
} from "../../components/RoleBasedComponents";
import PERMISSIONS from "../../permissions";
import EditFuelTransaction from "../Fuel/EditFuelTransaction";
import NewFuelStation from "../NewFuelStation";
import EditEntity from "../../components/EditEntity/EditEntity";

function FuelStations() {
  const navigate = useNavigate();
  const { userPermissions } = useAuth();

  const [data, setData] = useState([]);
  const [rowId, setRowId] = useState(null);
  const [editRowId, setEditRowId] = useState(null);
  
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isDetails, setDetails] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [hasMorePages, setHasMorePages] = useState(true);
  const [fuelReceiptStatus, setFuelReceiptStatus] = useState("");
  const [showFile, setShowFile] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const [fileType, setFileType] = useState(null);


  // useEffect(() => {
  //   console.log("Fuel Component Re-rendered: ", { filters, currentPage, data });
  // });
  

  console.log("Filter Component Rendered");


  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const handleEdit = () => {
    console.log("Edit clicked for row:");
    setEdit(true);
    setModalOpen(true);
    setDetails(false);
    setShowFile(false);
    setEditRowId(rowId);
  };

  const handleDetails = () => {
    console.log("Details clicked for row:");
    setDetails(true);
    setModalOpen(true);
    setEdit(false);
    setShowFile(false);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setEdit(false);
    setDetails(false);
    setShowFile(false);
  };

  const handleRowClick = (row) => {
    setRowId(row);
  };

  const buttons = [{ label: "Details", onClick: () => handleDetails() }];

  if (
    hasPermission(userPermissions, PERMISSIONS.VENDOR_FUEL_STATION_UPDATE)
  ) {
    buttons.push({ label: "Edit", onClick: () => handleEdit() });
  }

  useEffect(() => {
    fetchData();
  }, [ currentPage ]);

  const fetchData = async () => {
    try {
      const params = new URLSearchParams({
        page_size: 12,
        page: currentPage,
      });
      const response = await ApiManager.getAllFuelStations(params);
      if (!response.ok) throw new Error("faild to fetch fuel transactions");
      const json = await response.json();
      console.log("res", json);

      if (JSON.stringify(json) !== JSON.stringify(data)) {
        setData(json || []);
        console.log("now data is",data)
        setHasMorePages(json.length == 12);
        // setFuelReceiptStatus(json.status);
      }
    } catch (error) {
      console.log("error", error);
      setData([]);
      setHasMorePages(false);
    }
  };

  console.log("data data data ", data)

  const columns = [
    { field: "name", headerName: "Name" },
    { field: "description", headerName: "Description" },
    { field: "location", headerName: "Location" },
  ];
  const view_columns = [
    { field: "name", headerName: "Name" },
    { field: "description", headerName: "Description" },
    { field: "location", headerName: "Location" },
  ];
  const edit_columns = [
    { name: "name",        label: "Name"        },
    { name: "description", label: "Description" },
    { name: "location",    label: "Location"    },
  ];

  const rows = (data || []).map((item) => ({
    id: item.id,
    name: item.name,
    description: item.description,
    location: item.location
  }));

  const handleFilterChange = (filterValues) => {
    setFilters(filterValues);
  };


  const handleEditStation = async (formData) => {
    const updatedFormData = {
      ...formData,
    };

    console.log("row row id ", rowId)

    const query = new URLSearchParams({
      id: editRowId,
    });
    const response = await ApiManager.updateFuelStation(
      query,
      updatedFormData
    );
    return response;
  };
  
  return (
    <div>
      <TopNavbar
        title="Fuel Stations"
      />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          paddingTop: "20px",
          height: "5vh",
        }}
      >        
        <ShowButton permission={PERMISSIONS.VENDOR_FUEL_STATION_CREATE}> 
            <NewFuelStation onSuccess={fetchData} />
        </ShowButton>
      </div>

      <Table
        table_columns={columns}
        view_columns={columns}
        rows={rows}
        setRowsId={setRowId}
        buttons={buttons}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        hasMorePages={hasMorePages}
        // onFieldUpdate={handleFieldUpdate}
      />
      {isModalOpen && isDetails && (
        <div className="details-container">
          <Modal isOpen={isModalOpen} onClose={handleModalClose}>
            <ViewEntity
              id={rowId}
              columns={view_columns}
              data={rows.find((row) => row.id === rowId)}
              entity="id"
            />
          </Modal>
        </div>
      )}
      {isModalOpen && isEdit && (
        // <div className="edit-container">
          <Modal isOpen={isModalOpen} onClose={handleModalClose}>
            <EditEntity
                id={rowId}
                updateFunction={handleEditStation}
                prevData={rows.find((row) => row.id === rowId)}
                columns={edit_columns}
                toggleFunction={toggleModal}
                onSuccess={fetchData}    
                title="Edit Fuel Station"
            />
          </Modal>
        // </div>
      )}
    </div>
  );
}

export default FuelStations;
